module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAJCAYAAADkZNYtAAAAHElEQVQYlWP8z8AARESAR1MYmIhSCAWjislWDABDtgOGOWLqSwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdystb1-4.png
// module id = 892
// module chunks = 0